import React, { useState } from "react";
import ComponentSc from "./index.sc";
import { useNavigate } from "react-router-dom";
import "./style.css";
interface props {
  data: any;
  idx: any;
  onClick: any;
}
function Index(props: props) {
  const [expanded, setExpanded] = useState(false);
  const { idx, data } = props;
  const toggleExpand = () => {
    setExpanded(!expanded);
  };
  const navigate = useNavigate();
  return (
    <>
      <ComponentSc>
        <div className="drop-down-heading" key={idx} onClick={toggleExpand}>
          {data?.heading}
        </div>
        {expanded && (
          <div className="list-containers">
            {data?.list?.map((item: any, idx: any) => (
              <div
                key={idx}
                onClick={() => navigate(item?.path)}
                className="list-items"
              >
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        )}
      </ComponentSc>
    </>
  );
}

export default Index;
